import { createSlice } from '@reduxjs/toolkit';

export const AppSlice = createSlice({
    name: "app",
    initialState: {
        orderDashboard:{
          filteredTaskId:0
        },
        title:'',
        orderType:'IN-PROGRESS',
        selectedProductOrderForStockOutReqId:'',
        
        addOrderStory: {
          title: "Add Order",
          description: "Select a party to add an order",
          currentState: "SELECT_PARTY",
        },
        editOrderStory: {
          title: "Edit Order",
          description: "Select a party to add an order",
          currentState: "ORDER_DASHBOARD",
        },
        tagMgmt:{
          tagList:[],
          selectedMonthTagId:0,
        },
        wkflow: {
          selectedWkfId:4,
          selectedStageId: '',
          selectedProductOrderId:'',
          selectedProductObj:null,
          refreshTaskList: false,
          refreshCommentList: false,
          enableAddComment: true,
          taskList: [],
          selectedTaskObj:{},
          completeTaskButtonEnabled: true,
          referbackTaskButtonEnabled: false,
          hideTaskActionBar: false,
          taskApiResponseError: '',
          taskApiResponse: null,
          itemIdBeingComment:0,
          commentList:[],
          checkRejectCondtion:true,
          taskCompleted: false,
          taskConfirmationMsg:'',
          productFilter:{
            orderid:'',
            partyname:'',
            brandname:'',
          },
          productCount:[{stageid:35,count:0},{stageid:28,count:0},{stageid:29,count:0},{stageid:30,count:0},{stageid:31,count:0},{stageid:32,count:0}],
          productIdByStageId:[],
          taskInstanceList:[],
        },
        
        orderType:"NEW",
        compType:0,
        selectedCTid:'',
        errMsg: "",
        infoMsg: "",
        snackbarMessage: "",
        snackbarOpen: false,
        openCommentDialogExternal: false,
        annotations:[],
        annotationMode:"READ"
      },
    reducers: {
      setFilteredTaskId : (state, action) =>{
        state.orderDashboard.filteredTaskId=action.payload;
      },
      setTitle : (state, action) =>{
        state.title = action.payload;
      },
      setOrderType : (state, action) =>{
        state.orderType=action.payload;
      },
      setSelectedProductOrderForStockOutReqId : (state, action) =>{
        state.selectedProductOrderForStockOutReqId = action.payload;
      },
      setAddOrderStoryState: (state, action) => {
        state.addOrderStory = action.payload;
      },
      setErrMsg : (state, action) => {
        state.errMsg = action.payload;
      },
      clearErrMsg : (state) => {
        state.errMsg = "";
      },
      setInfoMsg : (state, action) => {
        state.infoMsg = action.payload;
      },
      clearInfoMsg : (state) => {
        state.infoMsg = "";
      },
      setOrderType : (state, action) => {
        state.orderType = action.payload;
      },
      setEditOrderStory: (state, action) => {
        state.editOrderStory = action.payload;
      },
      setSelectedCTid: (state, action) => {
        state.selectedCTid = action.payload;
      },
      setSnackbarMessage: (state, action) => {
        state.snackbarMessage = action.payload;
      },
      setSnackbarOpen: (state, action) => {
        state.snackbarOpen = action.payload;
      },
      setOpenCommentDialogExternal: (state, action) => {
        state.openCommentDialogExternal = action.payload;
      },
      setTaskList: (state, action) => {
        state.wkflow.taskList = action.payload;
      },
      setSelectedTaskObj: (state, action) => {
        state.wkflow.selectedTaskObj = action.payload;
      },
      initRefreshTaskList: (state) => {
        state.wkflow.refreshTaskList = !state.wkflow.refreshTaskList;
      },
      setCompleteTaskButtonEnabled: (state, action) => {
        state.wkflow.completeTaskButtonEnabled = action.payload;
      },
      setHideTaskActionBar: (state, action) => {
        state.wkflow.hideTaskActionBar = action.payload;
      },
      setTaskApiResponse: (state, action) => {
        state.wkflow.taskApiResponse = action.payload;
      },
      setTaskApiResponseError : (state, action) => {
        state.wkflow.taskApiResponseError = action.payload;
      },
      setReferbackTaskButtonEnabled: (state, action) => {
        state.wkflow.referbackTaskButtonEnabled = action.payload;
      },
      setitemIdBeingComment: (state, action) => {
        state.wkflow.itemIdBeingComment = action.payload;
      },
      setCommentList: (state, action) => {
        state.wkflow.commentList = action.payload;
      },
      addCommentObj: (state, action)=>{
            state.wkflow.commentList.unshift(action.payload);
      },
      updateCommentObj: (state, action) => {
            // Find the index of the comment to update
            const index = state.wkflow.commentList.findIndex(commentObj => commentObj.id === action.payload.id);
            if (index > -1) {
                // Update the comment at the found index
                state.wkflow.commentList[index] = action.payload;
            }
        },
      deleteCommentObj: (state, action)=>{
            state.wkflow.commentList.splice(state.wkflow.commentList.findIndex(a => a.id === action.payload) , 1);
        },
      initRefreshCommentList: (state) => {
        state.wkflow.refreshCommentList = !state.wkflow.refreshCommentList;
      },
      setEnableAddComment: (state, action) => {
        state.wkflow.enableAddComment = action.payload;
      },
      setCheckRejectCondtion: (state, action) => {
        state.wkflow.checkRejectCondtion = action.payload;
      },
      setTaskCompleted: (state, action) => {
        state.wkflow.taskCompleted = action.payload;
      },
      setTaskConfirmationMsg: (state, action) => {
        state.wkflow.taskConfirmationMsg = action.payload;
      },
      setCompType : (state, action) =>{ 
        state.compType = action.payload;
      },
      setAnnotations: (state, action) => {
        state.annotations = action.payload;
      },
      deleteAnnotationById: (state, action) => {
        const idx = state.annotations.findIndex(a => a.id === action.payload);
        if (idx > -1) {
          state.annotations.splice(idx, 1);
        }
      },
      updateAnnotationById: (state, action) => {
        const idx = state.annotations.findIndex(a => a.id === action.payload.id);
        if (idx > -1) {
          state.annotations[idx] = action.payload;
        }
      },
      addAnnotations: (state, action) => {
        state.annotations.unshift(action.payload);
      },
      setAnnotationMode: (state, action) => {
        state.annotationMode = action.payload;
      },
      setProductFilter: (state, action) => {
        // action.payload should be an object like { key: 'orderid', value: '123' }
        const { key, value } = action.payload;
        if (key && key in state.wkflow.productFilter) {
          state.wkflow.productFilter[key] = value;
        }
      },
      setProductCount: (state, action) => {
        // action.payload should be { stageid, count }
        const { stageid, count } = action.payload;
        const idx = state.wkflow.productCount.findIndex(item => item.stageid === stageid);
        if (idx > -1) {
          state.wkflow.productCount[idx].count = count;
        }
      },
      insertProductIdsByStageId: (state, action) => {
        if (Array.isArray(action.payload)) {
          state.wkflow.productIdByStageId.push(...action.payload);
        } else {
          state.wkflow.productIdByStageId.push(action.payload);
        }
      },
      resetProductIdsByStageId: (state) => {
        state.wkflow.productIdByStageId = [];
      },
      insertTaskInstanceList: (state, action) => {
        if (Array.isArray(action.payload)) {
          state.wkflow.taskInstanceList.push(...action.payload);
        } else {
          state.wkflow.taskInstanceList.push(action.payload);
        }
      },
      resetTaskinstanceList: (state) => {
        state.wkflow.taskInstanceList = [];
      },
      setSelectedMonthTagId: (state, action) => {
        state.tagMgmt.selectedMonthTagId = action.payload;
      },
      setTagList: (state, action) => {
        state.tagMgmt.tagList = action.payload;
      },
      setSelectedWkfId: (state, action) => {    
        state.wkflow.selectedWkfId = action.payload;
      },
      setSelectedStageId: (state, action) => {    
        state.wkflow.selectedStageId = action.payload;  
      },
      setSelectedProductOrderId: (state, action) => {    
        state.wkflow.selectedProductOrderId = action.payload; 
      },
      setSelectedProductObj: (state, action) => {    
        state.wkflow.selectedProductObj = action.payload; 
      }
    }
});
export const {
  setSelectedMonthTagId,setTagList,setSelectedWkfId,setSelectedStageId,setSelectedProductOrderId,setSelectedProductObj,
  setAnnotationMode, setProductFilter, setProductCount,insertProductIdsByStageId,resetProductIdsByStageId,insertTaskInstanceList,resetTaskinstanceList,
  setCompType, setTaskConfirmationMsg, setTaskCompleted, setCheckRejectCondtion, setEnableAddComment, initRefreshCommentList,
  addCommentObj, updateCommentObj, deleteCommentObj, setCommentList, setitemIdBeingComment, setTaskApiResponse, setTaskApiResponseError,
  setHideTaskActionBar, setReferbackTaskButtonEnabled, setCompleteTaskButtonEnabled, initRefreshTaskList, setTaskList, setSelectedTaskObj,
  setOpenCommentDialogExternal, setSnackbarOpen, setSnackbarMessage, setSelectedCTid, setInfoMsg, clearInfoMsg, setEditOrderStory, setErrMsg,
  clearErrMsg, setAddOrderStoryState, setSelectedProductOrderForStockOutReqId, setFilteredTaskId, setTitle, setOrderType,
  setAnnotations, deleteAnnotationById, updateAnnotationById, addAnnotations
} = AppSlice.actions;
export default AppSlice.reducer;